"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "brandingSettings", {
  enumerable: true,
  get: function get() {
    return _brandingSettings["default"];
  }
});
var _brandingSettings = _interopRequireDefault(require("./brandingSettings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }